//属性数据
export const attribute = {
  account: [
    { label: "授权状态", value: "status" },
    { label: "账户余额", value: "balance" },
    { label: "预算", value: "budget", width: "140" },
  ],
  project: [
    { label: "项目状态", value: "status" },
    { label: "项目预算(元)", value: "budget" },
    { label: "转化目标", value: "externalAction" },
    { label: "计费类型", value: "budgetMode" },
    { label: "投放位置", value: "inventoryType" },
  ],
  advertise: [
    { label: "项目状态", value: "projectStatus" },
    { label: "项目名称", value: "projectName" },
    { label: "广告状态", value: "promotionStatus" },
    { label: "广告预算(元)", value: "budget" },
    { label: "广告出价", value: "bidAmount" },
    { label: "广告预算类型", value: "budgetMode" },
    { label: "深度转化出价", value: "deepBidAmount" },
  ],
};

//基础数据
export const baseData = [
  { label: "花费", value: "cost" },
  { label: "展示数", value: "showCnt" },
  { label: "点击数", value: "clickCnt" },
  { label: "点击率", value: "ctr" },
  { label: "点击成本(元)", value: "cpc" },
  { label: "千次展示成本(元)", value: "thousandDisplayPrice" },
];

//应用数据
export const appData = [
  { label: "激活数", value: "activeCnt" },
  { label: "激活成本(元)", value: "activeCost" },
  { label: "激活率", value: "activeRate" },
  { label: "转化数", value: "convertCnt" },
  { label: "转化成本(元)", value: "convertCntCost" },
  { label: "转化率", value: "convertCntRate" },
  { label: "深度转化数", value: "deepConvert" },
  { label: "深度目标转化率", value: "deepConvertRate" },
  { label: "深度转化成本(元)", value: "deepConvertCost" },
  { label: "安卓下载开始数", value: "downloadStart" },
  { label: "安卓下载开始成本(元)", value: "downloadStartCost" },
  { label: "安卓下载开始率", value: "downloadStartRate" },
  { label: "安卓下载完成数", value: "downloadFinish" },
  { label: "安卓下载完成成本(元)", value: "downloadFinishCost" },
  { label: "安卓下载完成率", value: "downloadFinishRate" },
  { label: "安卓安装完成数", value: "installFinish" },
  { label: "安卓安装完成成本(元)", value: "installFinishCost" },
  { label: "安卓安装完成率", value: "installFinishRate" },
  { label: "转化数(计费时间)", value: "attributionConvert" },
  { label: "转化成本(计费时间)", value: "attributionConvertCost" },
  { label: "转化率(计费时间)", value: "attributionConvertRate" },
  { label: "首次付费数", value: "activePay" },
  { label: "首次付费成本", value: "activePayCost" },
  { label: "首次付费率", value: "activePayRate" },
  { label: "付费次数", value: "payCount" },
  { label: "付费成本(元)", value: "payCost" },
  { label: "当日付费金额(元)", value: "payAmount" },
  { label: "当日付费ROI", value: "payRoi" },
  { label: "次日留存数", value: "attributionNextDayOpenCnt" },
  { label: "次日留存率", value: "nextDayRate" },
  { label: "次日留存成本(元)", value: "nextDayCost" },
];

//视频数据
export const videoData = [
  // {label: '有效播放率',value: 'valid_play_rate'},
  // {label: '播完率',value: 'play_over_rate'},
  // {label: '平均单次播放时长',value: 'average_play_time_per_play'},
];
/* 素材类型字段对象 */
export const materialFieldsObj = [
  { name: "素材类别", key: "materialTypes", optionsName: "materialTypeList", type: 1 },
  { name: "尺寸", key: "resolutions", optionsName: "dimensionList", type: 2 },
  { name: "语言", key: "langs", optionsName: "languageList", type: 3 },
  { name: "设计", key: "designerIds", optionsName: "designerList", type: 4 },
  { name: "后期", key: "demanderIds", optionsName: "demanderList", type: 5 },
  { name: "玩法", key: "playTypes", optionsName: "playList", type: 7 },
];
/* 素材类型字段枚举 */
export const materialRuleTypeOptions = [
  { label: "素材类别", value: 1, ruleOptions: "materialTypeRuleList", ruleId: "materialTypeRuleId" },
  { label: "尺寸", value: 2, ruleOptions: "dimensionRuleList", ruleId: "dimensionRuleId" },
  { label: "语言", value: 3, ruleOptions: "lanauageRuleList", ruleId: "langRuleId" },
  { label: "设计", value: 4, ruleOptions: "designerRuleList", ruleId: "designerRuleId" },
  { label: "后期", value: 5, ruleOptions: "demanderRuleList", ruleId: "demanderRuleId" },
  { label: "标签", value: 6, ruleOptions: "tagRuleList", ruleId: "tagRuleId" },
  { label: "玩法", value: 7, ruleOptions: "playTypeRuleList", ruleId: "playRuleId" },
];

/* 头条2.0项目状态字段枚举 */
export const projectStatusOptions = [
  { value: "PROJECT_STATUS_ENABLE", label: "启用" },
  { value: "PROJECT_STATUS_DISABLE", label: "暂停" },
  { value: "PROJECT_STATUS_BUDGET_EXCEED", label: "项目超出预算" },
  { value: "PROJECT_STATUS_BUDGET_PRE_OFFLINE_BUDGET", label: "项目接近预算" },
  { value: "PROJECT_STATUS_NOT_START", label: "未达投放时间" },
  { value: "PROJECT_STATUS_DONE", label: "已完成" },
  { value: "PROJECT_STATUS_NO_SCHEDULE", label: "不在投放时段" },
  { value: "PROJECT_STATUS_DELETE", label: "删除" },
];

/* 头条2.0广告状态字段枚举 */
export const adStatusOptions = [
  { value: "FROZEN", label: "已终止" },
  { value: "REAUDIT", label: "修改审核中" },
  { value: "AUDIT", label: "新建审核中" },
  { value: "AUDIT_DENY", label: "审核不通过" },
  { value: "DISABLED", label: "已暂停" },
  { value: "DISABLE_BY_QUOTA", label: "已暂停（配额达限）" },
  { value: "PROJECT_DISABLED", label: "已被项目暂停" },
  { value: "OFFLINE_BALANCE", label: "账户余额不足" },
  { value: "OFFLINE_BUDGET", label: "广告超出预算" },
  { value: "PROJECT_OFFLINE_BUDGET", label: "项目超出预算" },
  { value: "PREOFFLINE_BUDGET", label: "广告接近预算" },
  { value: "PROJECT_PREOFFLINE_BUDGET", label: "项目接近预算" },
  { value: "OK", label: "投放中" },
  { value: "NO_SCHEDULE", label: "不在投放时段" },
  { value: "TIME_NO_REACH", label: "未到达投放时间" },
  { value: "TIME_DONE", label: "已完成" },
  { value: "DELETED", label: "已删除" },
  { value: "LIVE_ROOM_OFF", label: "关联直播间不可投" },
  { value: "PRODUCT_OFFLINE", label: "关联商品不可投" },
  { value: "AWEME_ACCOUNT_DISABLED", label: "关联抖音账号不可投" },
  { value: "AWEME_ANCHOR_DISABLED", label: "锚点不可投" },
];

/* 头条2.0投放位置字段枚举 */
export const inventoryTypeOptions = [
  { label: "今日头条", value: "INVENTORY_FEED" },
  { label: "火山小视频", value: "INVENTORY_HOTSOON_FEED" },
  { label: "番茄小说", value: "INVENTORY_TOMATO_NOVEL" },
  { label: "西瓜视频", value: "INVENTORY_VIDEO_FEED" },
  { label: "通投智选", value: "INVENTORY_UNIVERSAL" },
  { label: "抖音", value: "INVENTORY_AWEME_FEED" },
  { label: "穿山甲", value: "INVENTORY_UNION_SLOT" },
  { label: "ohayoo精品游戏", value: "UNION_BOUTIQUE_GAME" },
];

/* 头条2.0转化目标字段枚举 */
export const externalActionOptions = [
  { value: "AD_CONVERT_TYPE_ACTIVE_REGISTER", label: "注册" },
  { value: "AD_CONVERT_TYPE_ACTIVE", label: "激活" },
  { value: "AD_CONVERT_TYPE_GAME_ADDICTION", label: "关键" },
  { value: "AD_CONVERT_TYPE_NEXT_DAY_OPEN", label: "次留" },
  { value: "AD_CONVERT_TYPE_LT_ROI", label: " 广告变现ROI" },
  { value: "AD_CONVERT_TYPE_PURCHASE_ROI", label: "付费ROI" },
  { value: "AD_CONVERT_TYPE_RETENTION_7D", label: "7日留存" },
];

/* 头条2.0计费类型字段枚举 */
export const budgetModeOptions = [
  { value: "BUDGET_MODE_INFINITE", label: "不限" },
  { value: "BUDGET_MODE_DAY", label: "日预算" },
];
